/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelMoneyInInput
 */
export interface CancelMoneyInInput {
    /**
     * Payment Account ID
     * @type {string}
     * @memberof CancelMoneyInInput
     */
    account: string;
}

/**
 * Check if a given object implements the CancelMoneyInInput interface.
 */
export function instanceOfCancelMoneyInInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "account" in value;

    return isInstance;
}

export function CancelMoneyInInputFromJSON(json: any): CancelMoneyInInput {
    return CancelMoneyInInputFromJSONTyped(json, false);
}

export function CancelMoneyInInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelMoneyInInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': json['account'],
    };
}

export function CancelMoneyInInputToJSON(value?: CancelMoneyInInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': value.account,
    };
}

